<div class="progress-loader" [hidden]="!loading">
    <div class="loading-spinner">
        <!-- <img src="https://loading.io/mod/spinner/typing/index.svg"> -->
        <!-- <span class="loading-message">Cargando...</span> -->
    </div>
</div>